/**
 * Prevent default if form is loading or swiper is animating
 * @param {Event} e - The event object to handle
 */
export function preventSkip(e) {
	if (window.modForm.opts.isFormLoading || window.modForm.opts.formSwiperInstance.animating) {
		e.preventDefault();
	}
}
